import React, { Component } from "react";
import PropTypes from "prop-types";

import styles from "./Subheader.css";

class Subheader extends Component {
  render() {
    const { isPrimary, headerLevels } = this.props;
    const headingLevel =
      isPrimary === true
        ? headerLevels.mainContentSubheading
        : headerLevels.contentSubheading;
    const HeadingTag = "h" + headingLevel;
    return (
      <HeadingTag className={styles.subhead}>{this.props.children}</HeadingTag>
    );
  }
}

Subheader.propTypes = {
  block: PropTypes.object.isRequired,
  headerLevels: PropTypes.object.isRequired,
  isPrimary: PropTypes.bool,
};

export default Subheader;
